<template>
  <common-dialog ref="dialog" :data="data" unit="语言资料" edit-title width="920px" :form-rules="rules" @closed="onClosed"
    :save-func="() => { }" :get-data-func="getDataFunc" @close-saved="$emit('close-saved')">
    <template slot="form">
      <el-row>
        <el-col :span="24">
          <span class>基础信息</span>
        </el-col>
      </el-row>
      <el-row class="row-border">
        <el-col>
          <el-form-item label="资料标题" prop="Title">
            <el-input v-model="data.Title" placeholder="请输入标题" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="资料类别" prop="Category">
            <el-select v-model="data.Category">
              <el-option value="科三灯光" label="科三灯光" />
              <el-option value="科三路考" label="科三路考" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="附件" prop="Attachments" class="is-required">
            <upload-audio-list :file-list="data.Attachments" uploadUrl="/api/Common/UploadMp3" @success="onSuccess" @delete="onDelete" :limitNum="1"></upload-audio-list>
          </el-form-item>
        </el-col>
      </el-row>
    </template>
    <template slot="footer" slot-scope="{isLoading}">
      <el-button type="warning" :loading="isLoading" @click.stop="toSave('save')">保 存</el-button>
      <el-button type="primary" :loading="isLoading" v-if="data.Status == 0 || data.Status == 2"
        @click.stop="toSave('submit')">提 交</el-button>

      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>

<script>
import uploadAudioList from "@/components/common/files/uploadAudioList";
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogMixin from "@/mixins/dialog";

export default {
  mixins: [editDialogMixin, dialogMixin],
  components: {
    commonDialog,
    uploadAudioList,
  },
  data() {
    let validator = (rule, value, callback) => {
      if (value.some(item => /^mp4|webm|ogg|mp3|wav|flac|aac$/.test(item.Extension)) || value == '') {
        callback();
      } else {
        callback("附件格式只能为手机音频格式");
      }
    };
    return {
      file: require("@/api/ent/ent").default,
      api: require("@/api/consult/lang").default,
      baseApi: require("@/api/common/common").default,
      data: {
        Attachments: [],
        VoiceId: 0,
        Title: "",
        Category: "",
        Status: 0,
        AddUserId: 0,
        AddDpId: 0,
        UpdateUserId: 0,
        ReviewUserId: 0,
      },
      rules: {
        Category: [{ required: true, message: "资料类别不能为空" }],
        Title: [{ required: true, message: "标题不能为空" }],
        Attachments: [
          { required: false, message: "附件只能为音频文件" },
          { validator: validator }
        ]
      },
      DelAttachments: [],
      isSubmit: false,
      // delAttachmentsList: [],
    };
  },
  methods: {
    getDataFunc(row) {
      return new Promise((resolve) => {
        this.api.info(row).then((res) => {
          //(res.Data.Attachments);
          //附件添加 修改 状态
          res.Data.Attachments.forEach((x) => (x.T = 1));
          //(this.data.Attachments);

          //选择对象添加 修改 状态
          resolve({ Data: res.Data });
        });
      });
    },
    onClosed() {
      this.data.Attachments = [];
      this.DelAttachments = [];
    },
    toSave(type) {
      //("??!",this.data.Attachments.length)
      if(this.data.Attachments.length==0) {
        this.$message.error("请上传附件");
        return false;
      }
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);

        //附件保存
        if (this.DelAttachments.length > 0) {
          this.DelAttachments.forEach((x) => data.Attachments.push(x));
        }

        
        this.$refs.dialog.isLoading = true;
        this.api[type](data).then((res) => {
            this.$refs.dialog.isLoading = false;
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        // if (this.isSubmit = type == 1) {
        //   this.api.submit(data).then((res) => {
        //     this.$refs.dialog.isLoading = false;
        //     if (res.Code == 0) {
        //       this.$message.success(res.Msg);
        //       this.$emit("close-saved");
        //       this.close(true);
        //     } else {
        //       this.$message.error(res.Msg);
        //     }
        //   });
        // } else {
        //   this.api.save(data).then((res) => {
        //     this.$refs.dialog.isLoading = false;
        //     if (res.Code == 0) {
        //       this.$message.success(res.Msg);
        //       this.$emit("close-saved");
        //       this.close(true);
        //     } else {
        //       this.$message.error(res.Msg);
        //     }
        //   });
        // }

      });
    },
    //上传成功回调
    onSuccess(res) {
      var data = res.Data;
      this.data.Attachments.push({
        Extension: data.Extension,
        FileName: data.FileName,
        FilePath: data.FilePath,
        Msg: data.Msg,
        FileUrl: data.VirtualPath,
        T: 0,
      });
    },
    //附件删除回调
    onDelete(index) {
      if(!(this.data.Attachments[index].T === 0)) {
        this.data.Attachments[index]["T"] = 2;
        this.DelAttachments.push(this.data.Attachments[index]);
      }
      this.data.Attachments.splice(index, 1);
    },
  },
};
</script>

<style scoped>
</style>